import { IMG_CDN_URL } from "../constants";
import { AiFillStar } from "react-icons/ai";
import {Link} from "react-router-dom";

const RestaurantCard = ({
  cloudinaryImageId,
  name,
  avgRating,
  cuisines,
  sla,
  id,
}) => {
  return (
    <article className="p-4 my-2 transition ease-out delay-75 hover:scale-105 ">
      <Link className="flex sm:flex-col" to={"restaurant/" + id}>
        {/* Image section */}
        <section className="w-1/3 relative sm:w-full h-28 sm:h-44 overflow-hidden rounded-xl">
          {cloudinaryImageId && (
            <img
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full max-h-none"
              src={IMG_CDN_URL + cloudinaryImageId}
            />
          )}
        </section>

        {/* Details section */}
        <section className="w-2/3 px-4 sm:w-auto sm:px-0">
          <div className="xl:text-lg sm:truncate font-semibold">{name}</div>
          <div className="text-xs lg:text-sm text-slate-500 truncate">
            {cuisines?.join(",")}
          </div>
          <div className="flex justify-between items-center my-2 text-xs lg:text-sm text-slate-700 font-medium">
            <span className="flex items-center">
              <AiFillStar
                className="shadow-lg text-2xl p-1 rounded-full"
                style={{
                  color: avgRating >= 4 ? "#228B22" : "#B8860B",
                }}
              />
              <span>{avgRating}</span>
            </span>
            <span className="card-del-time">{sla.slaString}</span>
          </div>
        </section>
      </Link>
    </article>
  );
};

export default RestaurantCard;